import {Dispatch, KeyboardEvent, SetStateAction, useEffect} from 'react'
import styled from 'styled-components'
import {getCurrentColors} from '../utils/colors'

interface FormFieldProps {
    label: string
    inputType: string
    state: string
    setState: Dispatch<SetStateAction<string>>
    submit: () => void
    autofocus?: boolean
    pattern?: string
}

const COLORS = getCurrentColors() // Importando as cores do tema atual

const Campo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin: 10px 0;

    & label {
        font-size: 12px;
        color: ${COLORS.cinzaEscuro};
    }

    & input {
        padding: 10px;
        width: 100%;
        color: #8b8b8b;
        border-radius: 8px;
        border: 1px solid #eeeeee;
        font-weight: regular;
    }
`
export default function FormField({
    submit,
    label,
    inputType,
    state,
    setState,
    autofocus = false,
    pattern,
}: FormFieldProps) {
    async function handleKeyUp(event: KeyboardEvent<HTMLInputElement>) {
        if (event.code === 'Enter' || event.code === 'NumpadEnter') {
            submit()
        }
    }

    useEffect(() => {
        // console.log(state)
    }, [state])
    return (
        <Campo>
            <input
                autoFocus={autofocus}
                onKeyUp={(event) => handleKeyUp(event)}
                value={state}
                onChange={(e) => setState(e.target.value)}
                type={inputType}
                placeholder={label}
                pattern={pattern}
            />
        </Campo>
    )
}
